export const runJSQueue = (fn: () => void) => {
  setTimeout(() => fn(), 0);
};
